(function () {
var $9d75711e9cd284e0$var$RelatedProducts = {
    init: function init() {
        var carousels = document.querySelectorAll('[data-related-products-carousel]');
        if (!carousels.length) return;
        this.swiperHandler(carousels);
    },
    swiperHandler: function swiperHandler(carousels) {
        carousels.forEach(function(carousel) {
            var container = carousel.closest('[data-related-products]');
            var nextButton = container.querySelector('[data-related-products-next]');
            var previousButton = container.querySelector('[data-related-products-previous]');
            var swiper = new Swiper(carousel, {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 24,
                allowTouchMove: false,
                navigation: {
                    nextEl: nextButton,
                    prevEl: previousButton
                }
            });
        });
    }
};
var $9d75711e9cd284e0$export$2e2bcd8739ae039 = $9d75711e9cd284e0$var$RelatedProducts;
$9d75711e9cd284e0$var$RelatedProducts.init();

})();
//# sourceMappingURL=script.js.map
